import React from "react";
import UiSearchInputField from "../../common/UiSearchInputField";

interface Props {
  searchTerm: string;
  onSearch: (term: string) => void;
}

/**
 * Recherche par label : même champ et même paramètre API (`searchTerm`)
 * que la recherche classique.
 */
const BatchLabelSearchField = ({ searchTerm, onSearch }: Props) => (
  <UiSearchInputField
    variant="modern"
    inGroup
    searchString={searchTerm}
    setSearchString={onSearch}
  />
);

export default BatchLabelSearchField;
